import React from "react";
import "./EducationListElement.css";
import { EducationListElement as EducationListElementType } from "../../types";

interface Props {
    education: EducationListElementType;
}

const EducationListElement: React.FC<Props> = ({ education }) => {
    const { title, timePeriod, description } = education;
    const [startYear, endYear] = timePeriod;

    return (
        <div className="education-box-list-element">
            <div className="education-box-list-element-top-container">
                <div className="education-box-list-element-title">{title}</div>
                <div className="education-box-list-element-time-period-text">
                    From: {startYear}-{endYear}
                </div>
            </div>
            <div className="education-box-list-element-bottom-container">
                <div className="education-box-list-element-description">
                    {description}
                </div>
            </div>
        </div>
    );
};

export default EducationListElement;
